<template>
  <div id="mypage">
    <LoadingSpinner :visible="isLoading" />

    <div class="page-header">
      <div class="header-bg"></div>
      <div class="container">
        <h2 class="page-title">MY PAGE</h2>
      </div>
    </div>

    <section class="main-section">
      <div class="container">
        <div class="row g-4">

          <!-- ==============================
            왼쪽 사이드바 / 개인정보
          =============================== -->
          <div class="col-lg-3">
            <div class="sidebar">

              <!-- 프로필 카드 -->
              <div class="profile-card">
                <div class="profile-photo-wrap">
                  <div @click="changePhoto()" class="photo-circle" title="사진 변경">
                    <img v-if="(this.userInfo.photo == '' || this.userInfo.photo == null)"
                      src="../assets/img/new-test/nonperson.png" class="photo-img" />
                    <img v-else :src="`/download/memberPhoto/${this.userInfo.photo}`" class="photo-img" />
                    <div class="photo-overlay"><i class="bi bi-camera-fill"></i></div>
                  </div>
                  <button @click="deletePhoto()" class="photo-del-btn" title="사진 삭제">
                    <i class="bi bi-x-lg"></i>
                  </button>
                  <input type="file" ref="fileInput" style="display: none" @change="handleFileChange()" id="fileInput">
                </div>

                <div class="profile-info">
                  <p class="profile-name">{{ this.userInfo.uNickName }} <span class="nim">님</span></p>
                  <p class="profile-detail"><i class="bi bi-telephone-fill me-1"></i>{{ this.userInfo.alimCallC }}</p>
                  <p class="profile-detail"><i class="bi bi-envelope-fill me-1"></i>{{ this.user.email }}</p>

                  <div v-if="this.userInfo.newMem === 'Y'" class="membership-badge">
                    <img src="../assets/img/main/membership_icon.png" alt="Membership Badge" class="badge-img" style="width:30px;">
                    <div>
                      <span class="badge-title">엔데이트립 멤버십 ({{ this.user.memNo }})</span>
                      <!-- <span class="badge-no">{{ this.user.memNo }}</span> -->
                      <span class="badge-exp">~ {{ this.getDateFormat(this.user.memExpDate) }}</span>
                    </div>
                  </div>
                  <div v-else class="membership-join">
                    <button type="button" class="btn btn-join" @click="joinToMembership(this.userInfo.uEmail)">
                      <i class="bi bi-star-fill me-1"></i>멤버십 가입
                    </button>
                  </div>

                  <button type="button" class="btn btn-edit-info" @click="goToMyPageInfoChange()">
                    <i class="bi bi-pencil-fill me-1"></i>나의정보 수정
                  </button>
                </div>
              </div>

              <!-- 포인트 카드 -->
              <div class="point-card">
                <div class="point-label"><i class="bi bi-coin me-1"></i>보유 포인트</div>
                <a href="/pointList_client" class="point-value">
                  {{ this.getCurrencyFormat(this.availPoint) }}<span class="point-unit">P</span>
                </a>
              </div>

              <!-- 쿠폰 등록 카드 -->
              <div class="coupon-reg-card">
                <p class="coupon-reg-title"><i class="bi bi-tag-fill me-1"></i>쿠폰 등록</p>
                <input type="text" class="coupon-input" placeholder="쿠폰번호 입력" v-model="regCpCode">
                <button type="button" class="btn btn-coupon-reg" @click="regCoupon(regCpCode.trim())">등록</button>
              </div>

            </div>
          </div>

          <!-- ==============================
            오른쪽 / 예약 & 문의
          =============================== -->
          <div class="col-lg-9">

            <!-- ---- 여행상품 예약내역 ---- -->
            <div class="content-card mb-4">
              <div class="card-header-row">
                <h4 class="section-title">
                  <span class="title-bar"></span>여행상품 예약내역
                </h4>
                <div class="header-right">
                  <span class="pay-legend">
                    <i class="bi bi-c-circle-fill text-warning"></i> 현금/카드
                    &nbsp;
                    <i class="bi bi-p-circle-fill text-success"></i> 포인트/쿠폰
                  </span>
                  <a href="javascript:void(0);" class="toggle-link"
                     @click="getRequestConsultList('past')" v-if="this.dFlag != 'past'">
                    지난예약 <i class="bi bi-chevron-right"></i>
                  </a>
                  <a href="javascript:void(0);" class="toggle-link active"
                     @click="getRequestConsultList()" v-else>
                    현재예약 <i class="bi bi-chevron-right"></i>
                  </a>
                </div>
              </div>

              <!-- PC 테이블 -->
              <div class="table-wrap pc-table">
                <table class="res-table">
                  <thead>
                    <tr>
                      <th>예약날짜 / 예약번호</th>
                      <th>상태</th>
                      <th>상품명</th>
                      <th>결제금액</th>
                      <th>일정</th>
                      <th>취소</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr :key="i" v-for="(rList, i) in this.reqListAll">
                      <td>
                        <span class="date-text">{{ this.getDateFormat(rList.insDate) }}</span>
                        <a @click="goToReqReserveDetail('R', rList.resCode, rList.reqPdtCode, rList.ntCd1);" class="res-code-link">{{ rList.resCode }}</a>
                      </td>

                      <td v-if="rList.reqStatus === 'WP'">
                        <span class="status-badge status-wait">{{ rList.accPayStatus }}</span>
                      </td>
                      <td v-else>
                        <span v-if="rList.reqStatus === 'RP' && rList.paidId == undefined" class="status-badge status-danger">{{ rList.procName }}</span>
                        <span v-else-if="rList.reqStatus === 'RP' && rList.paidId != undefined" class="status-badge status-danger">{{ rList.procName }}<br><small>(결제완료)</small></span>
                        <span v-else-if="rList.payStyle === 'f' && rList.reqStatus === 'PY'" class="status-badge status-danger">전액결제</span>
                        <span v-else-if="rList.payStyle === 'f' && rList.reqStatus === 'CO'" class="status-badge status-danger">{{ rList.procName }}</span>
                        <span v-else-if="rList.payStyle === 'p'" class="status-badge status-partial">부분결제</span>
                        <span v-else-if="rList.reqStatus === 'CX'" class="status-badge status-cancel"><s>{{ rList.procName }}</s></span>
                        <span v-else class="status-badge status-default">{{ rList.procName }}</span>
                      </td>

                      <td>
                        <a @click="goToProductDetail(rList.reqPdtCode);" class="product-link">{{ rList.resName }}</a>
                      </td>

                      <td>
                        <strong class="price-main">{{ this.getCurrencyFormat(rList.cstPrice_new) }}</strong>
                        <div class="price-detail" v-if="rList.payStyle === 'p'">
                          <span><i class="bi bi-c-circle-fill text-warning"></i> {{ this.getCurrencyFormat(rList.actualPayAmount) }}</span>
                          <span><i class="bi bi-p-circle-fill text-success"></i> {{ this.getCurrencyFormat(rList.pPoint1 + rList.pCoupon1) }}</span>
                        </div>
                        <div class="price-detail" v-if="rList.payStyle === 'f'">
                          <span><i class="bi bi-c-circle-fill text-warning"></i> {{ this.getCurrencyFormat(rList.actualPayAmount) }}</span>
                          <span><i class="bi bi-p-circle-fill text-success"></i> {{ this.getCurrencyFormat(rList.pPoint1 + rList.pPoint2 + rList.pCoupon1 + rList.pCoupon2) }}</span>
                        </div>
                      </td>

                      <td>
                        <span v-if="!rList.startDate" class="text-muted">-</span>
                        <span v-else-if="rList.reqPdtCode.charAt(0) === 'F'" class="date-text">{{ getDateFormat(rList.startDate) }}<br><small>(출발일)</small></span>
                        <span v-else class="date-text">{{ getDateFormat(rList.startDate) }}<br>~ {{ getDateFormat(rList.closeDate) }}</span>
                      </td>

                      <td v-if="this.dFlag != 'past'">
                        <div v-if="rList.reqStatus != 'CX'">
                          <button type="button" class="btn btn-cxl-outline"
                                  @click="reqCxl(rList.resCode,'i',i,rList.reqPdtCode)"
                                  v-if="rList.reqCxlResCode == undefined">요청</button>
                          <button type="button" class="btn btn-cxl-ing"
                                  @click="reqCxl(rList.resCode,'i',i,rList.reqPdtCode)" v-else disabled>요청중</button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <!-- 모바일 카드 -->
              <div class="mobile-cards">
                <div :key="i" v-for="(rList, i) in this.reqListAll" class="mobile-res-card">
                  <div class="mobile-card-header">
                    <i class="bi bi-airplane-fill me-2"></i>{{ rList.resName }}
                  </div>
                  <div class="mobile-card-body">
                    <div class="mobile-row">
                      <span class="mobile-label">예약번호</span>
                      <a @click="goToReqReserveDetail('R', rList.resCode, rList.reqPdtCode, rList.ntCd1);"
                         class="res-code-link">{{ rList.resCode }}</a>
                    </div>
                    <div class="mobile-row">
                      <span class="mobile-label">상태</span>
                      <span v-if="rList.reqStatus === 'WP'">{{ rList.accPayStatus }}</span>
                      <span v-else-if="rList.reqStatus === 'RP' && rList.paidId == undefined" class="text-danger">{{ rList.procName }}</span>
                      <span v-else-if="rList.reqStatus === 'RP' && rList.paidId != undefined" class="text-danger">{{ rList.procName }} (결제완료)</span>
                      <span v-else-if="rList.payStyle === 'f' && rList.reqStatus === 'PY'" class="text-danger">전액결제</span>
                      <span v-else-if="rList.payStyle === 'f' && rList.reqStatus === 'CO'" class="text-danger">{{ rList.procName }}</span>
                      <span v-else-if="rList.payStyle === 'p'" class="text-warning">부분결제</span>
                      <span v-else-if="rList.reqStatus === 'CX'" class="text-muted"><s>{{ rList.procName }}</s></span>
                      <span v-else>{{ rList.procName }}</span>
                    </div>
                    <div class="mobile-row">
                      <span class="mobile-label">결제금액</span>
                      <div>
                        <strong>{{ this.getCurrencyFormat(rList.cstPrice_new) }}</strong>
                        <div class="price-detail" v-if="rList.payStyle === 'p'">
                          <span><i class="bi bi-c-circle-fill text-warning"></i> {{ this.getCurrencyFormat(rList.actualPayAmount) }}</span><br>
                          <span><i class="bi bi-p-circle-fill text-success"></i> {{ this.getCurrencyFormat(rList.pPoint1 + rList.pCoupon1) }}</span>
                        </div>
                        <div class="price-detail" v-if="rList.payStyle === 'f'">
                          <span><i class="bi bi-c-circle-fill text-warning"></i> {{ this.getCurrencyFormat(rList.actualPayAmount) }}</span><br>
                          <span><i class="bi bi-p-circle-fill text-success"></i> {{ this.getCurrencyFormat(rList.pPoint1 + rList.pPoint2 + rList.pCoupon1 + rList.pCoupon2) }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="mobile-row">
                      <span class="mobile-label">예약날짜</span>
                      <span>{{ this.getDateFormat(rList.insDate) }}</span>
                    </div>
                    <div class="mobile-row">
                      <span class="mobile-label">일정</span>
                      <span v-if="!rList.startDate">-</span>
                      <span v-else-if="rList.reqPdtCode.charAt(0) === 'F'">{{ getDateFormat(rList.startDate) }} (출발일)</span>
                      <span v-else>{{ getDateFormat(rList.startDate) }} ~ {{ getDateFormat(rList.closeDate) }}</span>
                    </div>
                    <div class="mobile-row" v-if="this.dFlag != 'past' && rList.reqStatus != 'CX'">
                      <span class="mobile-label">취소</span>
                      <button type="button" class="btn btn-cxl-outline btn-sm"
                              @click="reqCxl(rList.resCode,'i',i,rList.reqPdtCode)"
                              v-if="rList.reqCxlResCode == undefined">취소요청</button>
                      <button type="button" class="btn btn-cxl-ing btn-sm"
                              @click="reqCxl(rList.resCode,'i',i,rList.reqPdtCode)" v-else disabled>취소요청중</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- ---- 호텔 예약내역 ---- -->
            <div class="content-card mb-4">
              <div class="card-header-row">
                <h4 class="section-title">
                  <span class="title-bar" style="background:#1a6eb5"></span>호텔 예약내역
                </h4>
                <div class="header-right">
                  <a href="javascript:void(0);" class="toggle-link"
                    @click="getHotelBookingList('past')" v-if="hFlag != 'past'">
                    지난예약 <i class="bi bi-chevron-right"></i>
                  </a>
                  <a href="javascript:void(0);" class="toggle-link active"
                    @click="getHotelBookingList()" v-else>
                    현재예약 <i class="bi bi-chevron-right"></i>
                  </a>
                </div>
              </div>

              <!-- PC 테이블 -->
              <div class="table-wrap pc-table">
                <table class="res-table">
                  <thead>
                    <tr>
                      <th>예약일 / 예약번호</th>
                      <th>상태</th>
                      <th>호텔명 / 객실</th>
                      <th>체크인 ~ 체크아웃</th>
                      <th>인원/객실</th>
                      <th>결제금액</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="hotelBookingList.length === 0">
                      <td colspan="6" class="text-center text-muted" style="padding:2rem;">
                        호텔 예약 내역이 없습니다.
                      </td>
                    </tr>
                    <tr v-for="(h, i) in hotelBookingList" :key="i">
                      <td>
                        <span class="date-text">{{ getDateFormat(h.created_at) }}</span>
                        <a @click="goToHotelBookingDetail(h.booking_no)" class="res-code-link" style="color:#1a6eb5;">
                          {{ h.booking_no }}
                        </a>
                      </td>
                      <td>
                        <span :class="['status-badge', hotelStatusBadge(h.status).cls]">
                          {{ hotelStatusBadge(h.status).text }}
                        </span>
                      </td>
                      <td style="text-align:left;">
                        <span style="font-weight:600; font-size:0.82rem;">{{ h.hotel_name }}</span>
                        <br>
                        <small class="text-muted">{{ h.room_desc || '-' }}</small>

                        <!-- ✅ 호텔 승인번호 (있을 때만 표시) -->
                        <div v-if="h.hotel_conf_id" style="margin-top:4px;">
                          <span style="display:inline-block; font-size:0.68rem; background:#e6f4ea; color:#2d6a4f; font-weight:600; padding:2px 7px; border-radius:4px; border:1px solid #b7dfbf;">
                            🏨 승인번호: {{ h.hotel_conf_id }}
                          </span>
                        </div>
                      </td>
                      <td>
                        <span class="date-text">{{ this.getDateFormat(h.check_in) }} ~ {{ this.getDateFormat(h.check_out) }}</span>
                        <br>
                        <small class="text-muted">{{ h.night_count }}박</small>
                      </td>
                      <td>
                        <small>성인 {{ h.adult_count }}명 / {{ h.room_count }}실</small>
                      </td>
                      <td>
                        <strong class="price-main">{{ getCurrencyFormat(h.selling_krw) }}원</strong>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <!-- 모바일 카드 -->
              <div class="mobile-cards">
                <div v-if="hotelBookingList.length === 0" class="text-center text-muted py-4">
                  호텔 예약 내역이 없습니다.
                </div>
                <div v-for="(h, i) in hotelBookingList" :key="i" class="mobile-res-card">
                  <div class="mobile-card-header" style="background:linear-gradient(135deg,#1a6eb5,#0f4a8a)">
                    <i class="bi bi-building me-2"></i>{{ h.hotel_name }}
                  </div>
                  <div class="mobile-card-body">
                    <div class="mobile-row">
                      <span class="mobile-label">예약번호</span>
                      <a @click="goToHotelBookingDetail(h.booking_no)" class="res-code-link" style="color:#1a6eb5;">
                        {{ h.booking_no }}
                      </a>
                    </div>
                    <div class="mobile-row">
                      <span class="mobile-label">상태</span>
                      <span :class="['status-badge', hotelStatusBadge(h.status).cls]">
                        {{ hotelStatusBadge(h.status).text }}
                      </span>
                    </div>
                    <div class="mobile-row">
                      <span class="mobile-label">객실</span>
                      <span>{{ h.room_desc || '-' }}</span>
                    </div>
                    <!-- ✅ 호텔 승인번호 (있을 때만) -->
                    <div class="mobile-row" v-if="h.hotel_conf_id">
                      <span class="mobile-label">승인번호</span>
                      <span style="font-size:0.72rem; background:#e6f4ea; color:#2d6a4f; font-weight:600; padding:2px 7px; border-radius:4px;">
                        {{ h.hotel_conf_id }}
                      </span>
                    </div>
                    <div class="mobile-row">
                      <span class="mobile-label">체크인</span>
                      <span>{{ this.getDateFormat(h.check_in) }} ~ {{ this.getDateFormat(h.check_out) }} ({{ h.night_count }}박)</span>
                    </div>
                    <div class="mobile-row">
                      <span class="mobile-label">인원</span>
                      <span>성인 {{ h.adult_count }}명 / {{ h.room_count }}실</span>
                    </div>
                    <div class="mobile-row">
                      <span class="mobile-label">결제금액</span>
                      <strong>{{ getCurrencyFormat(h.selling_krw) }}원</strong>
                    </div>
                  </div>
                </div>
              </div>
            </div>


            <!-- ---- 엔버스 예약내역 ---- -->
            <div class="content-card mb-4">
              <div class="card-header-row">
                <h4 class="section-title">
                  <span class="title-bar" style="background:var(--teal)"></span>엔버스 예약내역
                </h4>
                <div class="header-right">
                  <a href="javascript:void(0);" class="toggle-link" @click="getRequestConsultList_nbus('past')" v-if="this.dFlag_nbus != 'past'">
                    지난예약 <i class="bi bi-chevron-right"></i>
                  </a>
                  <a href="javascript:void(0);" class="toggle-link active" @click="getRequestConsultList_nbus()" v-else>
                    현재예약 <i class="bi bi-chevron-right"></i>
                  </a>
                </div>
              </div>

              <!-- PC 테이블 -->
              <div class="table-wrap pc-table">
                <table class="res-table">
                  <thead>
                    <tr>
                      <th>예약날짜 / 엔버스번호</th>
                      <th>상태</th>
                      <th>출발일(이용일수) / 출발장소</th>
                      <th>결제금액</th>
                      <th>인원</th>
                      <th>취소</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr :key="i" v-for="(rList, i) in this.reqListAll_nbus">
                      <td>
                        <span class="date-text">{{ this.getDateFormat(rList.insDate) }}</span>
                        <a @click="goToReqReserveDetail('N', rList.inqCode);" class="res-code-link nbus-link">{{ rList.inqCode }}</a>
                      </td>
                      <td v-if="rList.inqStatus === 'WP'">
                        <span class="status-badge status-wait">{{ rList.accPayStatus }}</span>
                      </td>
                      <td v-else>
                        <span v-if="rList.inqStatus === 'RP' && rList.paidId == undefined" class="status-badge status-danger">{{ rList.procName }}</span>
                        <span v-else-if="rList.inqStatus === 'RP' && rList.paidId != undefined" class="status-badge status-danger">{{ rList.procName }}<br><small>(결제완료)</small></span>
                        <span v-else-if="rList.payStyle === 'f'" class="status-badge status-danger">전액결제</span>
                        <span v-else-if="rList.payStyle === 'p'" class="status-badge status-partial">부분결제</span>
                        <span v-else-if="rList.inqStatus === 'CX'" class="status-badge status-cancel"><s>{{ rList.procName }}</s></span>
                        <span v-else-if="rList.inqStatus === 'CO'" class="status-badge status-done">{{ rList.procName }}</span>
                        <span v-else class="status-badge status-default">{{ rList.procName }}</span>
                      </td>
                      <td class="date-text">
                        {{ getDateFormat(rList.rentStartDate) }}
                        <span class="days-badge">({{ rList.rentTotDays }}일간)</span>
                        <br><small class="text-muted">{{ rList.deptPoint }}</small>
                      </td>
                      <td>
                        <strong class="price-main">{{ this.getCurrencyFormat(rList.nbusPriceTot) }}</strong>
                        <div v-if="rList.payStyle === 'p'" class="price-detail">
                          <span class="text-warning">({{ this.getCurrencyFormat(rList.actualPayAmount) }})</span>
                        </div>
                      </td>
                      <td>{{ getCurrencyFormat(rList.personCnt) }}</td>
                      <td v-if="this.dFlag_nbus != 'past'">
                        <div v-if="rList.inqStatus != 'CX'">
                          <button type="button" class="btn btn-cxl-outline"
                                  @click="reqCxl_nbus(rList.inqCode,'n',i)"
                                  v-if="rList.reqCxlResCode == undefined">요청</button>
                          <button type="button" class="btn btn-cxl-ing"
                                  @click="reqCxl_nbus(rList.inqCode,'n',i)" v-else disabled>요청중</button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <!-- 모바일 카드 -->
              <div class="mobile-cards">
                <div :key="i" v-for="(rList, i) in this.reqListAll_nbus" class="mobile-res-card nbus-card">
                  <div class="mobile-card-header" style="background: linear-gradient(135deg,#2a9d8f,#1d7a6f)">
                    <i class="bi bi-bus-front-fill me-2"></i>{{ getDateFormat(rList.rentStartDate) }}
                  </div>
                  <div class="mobile-card-body">
                    <div class="mobile-row">
                      <span class="mobile-label">엔버스번호</span>
                      <a @click="goToReqReserveDetail('N', rList.inqCode);" class="res-code-link nbus-link">{{ rList.inqCode }}</a>
                    </div>
                    <div class="mobile-row">
                      <span class="mobile-label">상태</span>
                      <span v-if="rList.inqStatus === 'RP' && rList.paidId == undefined" class="text-danger">{{ rList.procName }}</span>
                      <span v-else-if="rList.inqStatus === 'RP' && rList.paidId != undefined" class="text-danger">{{ rList.procName }} (결제완료)</span>
                      <span v-else-if="rList.payStyle === 'f'" class="text-danger">전액결제</span>
                      <span v-else-if="rList.payStyle === 'p'" class="text-warning">부분결제</span>
                      <span v-else-if="rList.reqStatus === 'CX'" class="text-muted"><s>{{ rList.procName }}</s></span>
                      <span v-else-if="rList.inqStatus === 'CO'" class="text-primary">{{ rList.procName }}</span>
                      <span v-else>{{ rList.procName }}</span>
                    </div>
                    <div class="mobile-row">
                      <span class="mobile-label">결제금액</span>
                      <div>
                        <strong>{{ this.getCurrencyFormat(rList.nbusPriceTot) }}</strong>
                        <span class="text-warning" v-if="rList.payStyle === 'p'"> ({{ this.getCurrencyFormat(rList.actualPayAmount) }})</span>
                      </div>
                    </div>
                    <div class="mobile-row">
                      <span class="mobile-label">예약날짜</span>
                      <span>{{ this.getDateFormat(rList.insDate) }}</span>
                    </div>
                    <div class="mobile-row">
                      <span class="mobile-label">출발일 / 장소</span>
                      <span>{{ getDateFormat(rList.rentStartDate) }} ({{ rList.rentTotDays }}일간)<br>{{ rList.deptPoint }}</span>
                    </div>
                    <div class="mobile-row" v-if="this.dFlag_nbus != 'past' && rList.reqStatus != 'CX'">
                      <span class="mobile-label">취소</span>
                      <button type="button" class="btn btn-cxl-outline btn-sm"
                              @click="reqCxl_nbus(rList.inqCode,'n',i)"
                              v-if="rList.reqCxlResCode == undefined">취소요청</button>
                      <button type="button" class="btn btn-cxl-ing btn-sm"
                              @click="reqCxl_nbus(rList.inqCode,'n',i)" v-else disabled>취소요청중</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- ---- 문의 섹션 ---- -->
            <div class="content-card mb-4">
              <div class="card-header-row mb-3">
                <h4 class="section-title">
                  <span class="title-bar" style="background:#e9c46a"></span>문의 현황
                </h4>
              </div>
              <div class="row g-3">

                <!-- 1:1문의 -->
                <div class="col-md-4">
                  <div class="inquiry-card">
                    <div class="inquiry-icon-wrap" style="background:rgba(134,205,83,0.12)">
                      <i class="bi bi-chat-dots-fill" style="color:var(--green-dark)"></i>
                    </div>
                    <div class="inquiry-info">
                      <div class="inquiry-more">
                        <h5>1:1 문의</h5>
                        <a href="javascript:void(0);" @click="goToMyPageRequestList('one')" class="more-link">더보기</a>
                      </div>
                      <div class="inquiry-counts">
                        <div class="count-row">
                          <span class="count-label">문의요청</span>
                          <span class="count-val">{{ this.countCustomerAsk.totAsk }}<em>건</em></span>
                        </div>
                        <div class="count-row">
                          <span class="count-label">답변완료</span>
                          <span class="count-val answered">{{ this.countCustomerAsk.totAns }}<em>건</em></span>
                        </div>
                      </div>
                    </div>
                    <button class="btn btn-inquiry" @click="goToCustomerAskDetail()">문의하기</button>
                  </div>
                </div>

                <!-- 상품문의 -->
                <div class="col-md-4">
                  <div class="inquiry-card">
                    <div class="inquiry-icon-wrap" style="background:rgba(42,157,143,0.1)">
                      <i class="bi bi-bag-heart-fill" style="color:#2a9d8f"></i>
                    </div>
                    <div class="inquiry-info">
                      <div class="inquiry-more">
                        <h5>상품 문의</h5>
                        <a href="javascript:void(0);" @click="goToMyPageRequestList('item')" class="more-link">더보기</a>
                      </div>
                      <div class="inquiry-counts">
                        <div class="count-row">
                          <span class="count-label">문의요청</span>
                          <span class="count-val">{{ this.countInquiry.totAsk }}<em>건</em></span>
                        </div>
                        <div class="count-row">
                          <span class="count-label">답변완료</span>
                          <span class="count-val answered">{{ this.countInquiry.totAns }}<em>건</em></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- 견적문의 -->
                <div class="col-md-4">
                  <div class="inquiry-card">
                    <div class="inquiry-icon-wrap" style="background:rgba(233,196,106,0.15)">
                      <i class="bi bi-file-earmark-text-fill" style="color:#c8952a"></i>
                    </div>
                    <div class="inquiry-info">
                      <div class="inquiry-more">
                        <h5>견적 문의</h5>
                        <a href="javascript:void(0);" @click="goToMyPageRequestList('estimate')" class="more-link">더보기</a>
                      </div>
                      <div class="inquiry-counts">
                        <div class="count-row">
                          <span class="count-label">문의요청</span>
                          <span class="count-val">{{ this.countQuotation.totAsk }}<em>건</em></span>
                        </div>
                        <div class="count-row">
                          <span class="count-label">답변완료</span>
                          <span class="count-val answered">{{ this.countQuotation.totAns }}<em>건</em></span>
                        </div>
                      </div>
                    </div>
                    <button class="btn btn-inquiry" @click="goToRequestQuoDetail()">문의하기</button>
                  </div>
                </div>

              </div>
            </div>

            <!-- ---- 쿠폰정보 ---- -->
            <div class="content-card mb-4" id="couponTable">
              <div class="card-header-row">
                <h4 class="section-title">
                  <span class="title-bar" style="background:#e76f51"></span>보유 쿠폰
                </h4>
                <div class="header-right">
                  <a href="javascript:void(0);" class="toggle-link"
                     @click="getUserCouponInfo('past')" v-if="this.cFlag != 'past'">
                    지난쿠폰 <i class="bi bi-chevron-right"></i>
                  </a>
                  <a href="javascript:void(0);" class="toggle-link active"
                     @click="getUserCouponInfo()" v-else>
                    현재쿠폰 <i class="bi bi-chevron-right"></i>
                  </a>
                </div>
              </div>

              <div class="coupon-table-wrap">
                <table class="coupon-tbl">
                  <thead>
                    <tr>
                      <th>쿠폰명</th>
                      <th>쿠폰코드</th>
                      <th>발행일</th>
                      <th>기한일</th>
                      <th>사용일</th>
                      <th>예약번호</th>
                      <th>금액</th>
                      <th>사용가능</th>
                      <th>비고</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr :key="i" v-for="(cp, i) in this.couponInfo" :class="{ 'cp-disabled': cp.useStat === '' }">
                      <td data-label="쿠폰명">{{ cp.cpName }}</td>
                      <td data-label="쿠폰코드" class="cp-code">{{ cp.cpCode }}</td>

                      <td data-label="발행일">
                        <span v-if="!cp.memCpFlag">{{ this.getDateFormat(cp.cpIssueDate) }}</span>
                        <span v-else-if="cp.memCpFlag === 'Y' && cp.cpType == 'A'">{{ this.getDateFormat(cp.memCpStDate) }}</span>
                        <span v-else-if="cp.memCpFlag === 'Y' && cp.cpType == 'B'">{{ this.getDateFormat(cp.cpIssueDate) }}</span>
                      </td>

                      <td data-label="기한일">
                        <span class="cp-expiry" v-if="!cp.memCpFlag">{{ this.getDateFormat(cp.cpExpDate) }}</span>
                        <span class="cp-expiry" v-else-if="cp.memCpFlag === 'Y' && cp.cpType == 'A'">{{ this.getDateFormat(cp.memCpExDate) }}</span>
                        <span class="cp-expiry" v-else-if="cp.memCpFlag === 'Y' && cp.cpType == 'B'">{{ this.getDateFormat(cp.cpExpDate) }}</span>
                      </td>

                      <td data-label="사용일">
                        <span v-if="(cp.cpSeq || cp.mcpSeq) && cp.cpUseDate != undefined">{{ this.getDateFormat(cp.cpUseDate) }}</span>
                        <span v-else-if="(cp.cpSeq || cp.mcpSeq) && cp.cpUseDate == undefined" class="text-muted">-</span>
                      </td>

                      <td data-label="예약번호">
                        <span v-if="cp.resNo != undefined">{{ cp.resNo }}</span>
                        <span v-else class="text-muted">-</span>
                      </td>

                      <td data-label="금액">
                        <strong class="cp-price">{{ this.getCurrencyFormat(cp.cpPrice) }}</strong>
                        <span v-if="cp.cpPriceFlag==='A'"> 원</span>
                        <span v-if="cp.cpPriceFlag==='R'"> %</span>
                      </td>

                      <td data-label="사용가능">
                        <span :class="['use-stat', cp.useStat === 'Y' ? 'stat-ok' : 'stat-no']">
                          {{ cp.useStat }} <em>({{ cp.useStatText }})</em>
                        </span>
                      </td>

                      <td data-label="비고">
                        <span class="cp-remarks" v-if="!cp.memCpFlag"><pre>{{ cp.cpRemarks }}</pre></span>
                        <span class="cp-remarks" v-else-if="cp.memCpFlag === 'Y'"><pre>{{ cp.pContent }}</pre></span>
                      </td>
                      <td style="display:none">{{ cp.cpSubNo }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import moment from 'moment';
import { getAvailPoint } from "../assets/js/commonFunctions.js"
import { handlerInfo } from '../assets/js/commonFunctions'
import LoadingSpinner from '../components/LoadingSpinner.vue'

export default {
  components: {
    LoadingSpinner
  },
  data() {
    return {
      isLoading: false,

      reqFlag: "R",          //문의플래그
      //포인트관련
      userInfo: [],          //유저정보
      resUserPoint: [],
      availPoint: 0,         // 사용자 가용포인트

      userMemInfo: [],       //멤버십정보

      rProc: [],             //프로세스레벨

      //예약관련
      reqListAll: [],       //전체
      reqListEvt: [],       //마이행사
      resName: "",          //상품, 행사명 (통합) 
      dFlag: "",            //시기구분플래그

      tot_selOptPrice:  0,          //선택된 옵션총액

      //문의카운트
      countCustomerAsk: 0,  //1:1문의카운트정보
      countInquiry: 0,      //상품문의카운트정보
      countQuotation: 0,    //견적문의카운트정보

      reqList: [], //1:1문의

      //문의관련
      reqList_inq: [],

      //견적관련
      reqList_quo: [],

      //엔버스마이페이지 리스트
      reqListNbus: [],
      reqListAll_nbus: [],

      dFlag_nbus: "",            //엔버스 시기구분플래그

      //payStyle: "",            //p: 부분 , f: 전액

      handTel: [],                //매니저연락처
      handTelCnt: 0,               //수신처갯수

      couponInfo: [],           //쿠폰정보
      //userCoupon_info: [],      //표시쿠폰정보
      useStat: "",              //사용여부
      cFlag: "",                //쿠폰리스트 시기정보

      regCpCode: "",            //등록용쿠폰코드

      mLevel: "",               //멤버레벨(G, S, P)
      k_name: "",               //인적정보
      k_tel: "",

      myMemCpList: [],          //멤버십쿠폰리스트

      // 호텔예약
      hotelBookingList: [],
      hFlag: '',
    };
  },
  created(){
    //console.log("user:",this.$store.state.user); 
    
    if (this.$store.state.user.handlerId != undefined) {
      this.userId = this.$store.state.user.handlerId
    }
    else if (this.$store.state.user.email != undefined) {
      this.userId = this.$store.state.user.email
    }
    else {
      this.userId = ""
    }
    //console.log("userId:>>>>", this.userId)

    const today_tmp = moment();
    let today1 = moment([today_tmp.year(), today_tmp.month(), today_tmp.date()]);
    this.today = today1.format("YYYY-MM-DD")
    //console.log("today:",this.today)

    //회원정보
    this.getUserInfo();

    // //포인트관련(미확정이 있으면 제거가 먼저)
    // this.rmStandbyPoint();

    //예약관련
    this.getReqProcLevel();
    this.getRequestConsultList();               //일반상품 예약리스트
    this.getRequestConsultList_nbus();          //엔버스 예약리스트
    this.getHotelBookingList();                 //호텔예약리스트

    this.getHandlerInfo()                       //알림톡 발송대상 체크

    //카카오알림용 인적정보
    // if(this.user.joinFlag === "K" || this.user.joinFlag === "E" || this.user.joinFlag === "H" || this.user.joinFlag === "M")
    // {
    //   this.k_name = (!this.user.nickname) ? "" : this.user.nickname;

    //   let kakaoPhone = ""
    //   if(this.user.alimCallC != undefined && this.user.alimCallC.charAt(0) === '+')
    //   {
    //     //console.log("kakao:",this.user.phone.replace("+82 ", "0"))
    //     kakaoPhone = this.user.alimCallC.replace("+82 ", "0")
    //   }
    //   else
    //   {
    //     kakaoPhone = this.user.alimCallC
    //   }      
    //   this.k_tel = (!this.user.alimCallC) ? "" : kakaoPhone.replace(/-/g,""); //-제거       
    // }
    // else
    // {
    //   this.k_name = this.user.name;
    //   this.k_tel = (!this.user.mobile) ? "" : this.user.mobile.replace(/-/g,""); //-제거
    // }
    // //console.log("k_name:",this.k_name, "k_tel:",this.k_tel)
  },
  computed: {
    user() {
      return this.$store.state.user;
    }
  },
  mounted() {
    // if(document.referrer == "") {
    //   this.$swal.fire('', '적절하지 않은 페이지 접근입니다.', 'error');
    //   this.$router.push({path: '/'});
    // }
    //비회원 접근 시 대응처리
    if(!this.$store.state.user.email || this.$store.state.user.email == undefined) {
      // var swal = require('sweetalert2');
      // swal.fire({
      //   title: '',
      //   text: '로그인 후 이용해주세요.',
      //   icon: 'warning'
      // });
      this.$router.push({path: '/b2CLogin', query:{st: "Y"}});
    }

    const date = new Date(+new Date() + 3240 * 10000).toISOString().split("T")[0]

    this.todayTime = moment().format('YYYY-MM-DD HH:mm:ss');
    this.today = date
    this.todayCnt = this.today.replace(/-/g, "")        //날짜계산용
    //this.today = date + ' ' + time;

    // this.checkIssuedCoupon()                          //전체발행된 쿠폰체크+저장처리
  },  
  methods: {
    // 숫자 3자리마다 콤마 찍기
    getCurrencyFormat(value) {
      return this.$currencyFormat(value);
    },
    getDateFormat(date) {
      return this.$dateFormat(date);
    },

    // 호텔예약리스트 호출
    async getHotelBookingList(f) {
      this.hFlag = (f === 'past') ? 'past' : '';
      
      const list = await this.$api('/api/myHotelBookingList', {
        param: [this.user.email]
      });

      if (f === 'past') 
      {
        this.hotelBookingList = list.filter(e => e.check_out < this.today);
      } 
      else 
      {
        this.hotelBookingList = list.filter(e => e.check_out >= this.today);
      }
    },

    //호텔예약 상세보기
    goToHotelBookingDetail(bookingNo) {
      this.$router.push({ path: '/reserveInfoDetail_client', query: { bookingNo, cCode: 'H' } });
    },

    hotelStatusBadge(status) {
      const map = {
        'bkg-ip': { text: '처리중',     cls: 'status-wait'    },
        'bkg-ps': { text: '확인중',     cls: 'status-wait'    },
        'bkg-cf': { text: '예약확정',   cls: 'status-done'    },
        'bkg-cx': { text: '취소',       cls: 'status-cancel'  },
        'bkg-af': { text: '예약실패',   cls: 'status-danger'  },
      };
      return map[status] || { text: status, cls: 'status-default' };
    },


    // 회원집단에게 발행된 쿠폰체크
    async checkIssuedCoupon(mLv, mTel, mId) {
      const searcingIcon =
      '<svg xmlns="http://www.w3.org/2000/svg" width="50" fill="currentColor" class="bi bi-eyeglasses" viewBox="0 0 16 16"><path d="M4 6a2 2 0 1 1 0 4 2 2 0 0 1 0-4m2.625.547a3 3 0 0 0-5.584.953H.5a.5.5 0 0 0 0 1h.541A3 3 0 0 0 7 8a1 1 0 0 1 2 0 3 3 0 0 0 5.959.5h.541a.5.5 0 0 0 0-1h-.541a3 3 0 0 0-5.584-.953A2 2 0 0 0 8 6c-.532 0-1.016.208-1.375.547M14 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0"/></svg>'
      
      this.$swal.fire({
        //position: 'bottom-end',
        icon: 'info',
        iconHtml: searcingIcon,
        html: "<span style='font-size: 0.9rem;'>고객님을 위한 쿠폰이 있는지 찾아보고 있어요!!</span>",
        toast: true,
        showConfirmButton: false,
        timer: 2000
      })

      this.isLoading = true;
      try 
      {
        //await this.$api("/api/proc_checkMyCoupon", { param: [ mLv, mTel, mId ] })
        await this.$api("/api/proc_checkMyCoupon_new", { param: [ mLv, mTel, mId ] })       // 전체회원용 일반쿠폰이 발행된 것이 있으면 사용가능하게 저장해준다
      }
      catch(error)
      {
        this.$swal.fire("","처리 중 오류가 발생했습니다", "warning").then(() => {
          this.getUserCouponInfo()                          //소유쿠폰정보취득
        })
      }
      finally 
      {
        this.isLoading = false;
      }
      this.getUserCouponInfo()                          //소유쿠폰정보취득(멤버십전용쿠폰 포함)
    },

    // // 멤버십 쿠폰코드생성
    // async genCpCode_mem() {
    //   return await generateCouponCode_mem(this.$api, this.todayCnt);
    // },

    // 비활성 쿠폰등록
    async regCoupon(cpCode){
      let cc = await this.$api("/api/checkInactiveCoupon", {param: [ cpCode ]})

      if(cc.length < 1)
      {
        this.regCpCode = ""
        this.$swal.fire("", "등록가능한 쿠폰번호가 아닙니다.", "question")
        return false
      }
      else
      {
        let cd = await this.$api("/api/checkDub_inactivCoupon", {param: [ this.user.email, cpCode ]})
        if(cd.length > 0)
        {
          this.regCpCode = ""
          this.$swal.fire("", "이미 등록된 쿠폰입니다.", "warning")
          return false
        }
        else
        {
          let regUserCoupon = await this.$api("/api/proc_registCoupon", {param: [
            // uEmail, cpCode, cpUseFlag, uCall,
            this.user.email, cc[0].cpCode, "N", this.user.alimCallC, cc[0].cpIssueQtyIndef
          ]})

          if(regUserCoupon[0][0].affectedRows === 1)
          {
            this.$swal.fire("", "쿠폰이 등록되었습니다<br>감사합니다", "success").then(() => {
              this.regCpCode = ""
              this.getUserCouponInfo()
            })
          }
          else
          {
            let errorMsg = regUserCoupon[0][0].errorMessage || "쿠폰등록에 오류가 발생했습니다"
            this.$swal.fire("", errorMsg, "warning")
          }
        }
      }
    },

    async getUserCouponInfo(f){
      this.cFlag = (f==="past") ? 'past' : ''

      // 멤버십 전용쿠폰 발행체크
      let getMemCpList = await this.$api("/api/memberCouponList", {param: [ this.user.email ] })
      this.myMemCpList = getMemCpList;
      //console.log("myMemCpList:::::::", this.myMemCpList)

      // 멤버십전용 유효쿠폰 리스트
      let couponInfo = []
      if(f === "past")      //기간도과 또는 기사용으로 향후 사용불가 쿠폰
      {
        let couponInfo_tmp = await this.$api("/api/userCouponPast", {param: [this.user.email]});
        if(this.userInfo.newMem === "Y")
        {
          //멤버십전용쿠폰A past
          let couponInfo_mem_A = this.myMemCpList.filter(e => {
            return e.cpType == "A" && (e.cpUseFlag === "Y" || e.memCpExDate < this.todayTime) 
          })

          //멤버십전용쿠폰B past
          let couponInfo_mem_B = this.myMemCpList.filter(e => {
            return e.cpType == "B" && (e.cpUseFlag === "Y" || e.cpExpDate < this.todayTime) 
          })
          couponInfo_tmp = couponInfo_tmp.concat(couponInfo_mem_A, couponInfo_mem_B)
        }
        couponInfo = couponInfo_tmp;
      }
      else
      {
        let couponInfo_tmp = await this.$api("/api/userCouponNow", {param: [this.user.email]});
        if(this.userInfo.newMem === "Y")
        {
          //멤버십전용쿠폰A now
          let couponInfo_mem_A = this.myMemCpList.filter(e => {
            return e.cpType == "A" && (e.cpUseFlag === "N" && (e.cpExpDate >= this.todayTime && e.memCpExDate >= this.todayTime)) 
          })
          // console.log("couponInfo_mem_A::>>>", couponInfo_mem_A)

          //멤버십전용쿠폰B now
          let couponInfo_mem_B = this.myMemCpList.filter(e => {
            return e.cpType == "B" && (e.cpUseFlag === "N" && e.cpExpDate >= this.todayTime) 
          })
          // console.log("couponInfo_mem_B::>>>", couponInfo_mem_B)


          // let couponInfo_mem = await this.$api("/api/memCouponPast", {param: [this.user.email]});
          couponInfo_tmp = couponInfo_tmp.concat(couponInfo_mem_A, couponInfo_mem_B)
        }
        couponInfo = couponInfo_tmp;
      }
      //console.log("couponInfo>>>>>", couponInfo)

      if(couponInfo.length > 0) {
        let useStat = ""
        let useStatText = ""

        for(let i=0; i<couponInfo.length; i++)
        {
          // 일반쿠폰
          if(!couponInfo[i].memCpFlag) 
          {
            if(couponInfo[i].cpValidFlag == "N")
            {
              useStat = "N"   //사용불가
              useStatText = "사용정지"
              couponInfo[i].useStat = useStat
              couponInfo[i].useStatText = useStatText
            }
            // else if(couponInfo[i].cpValidFlag == "N")
            // {
            //   useStat = "N"   //사용불가
            //   useStatText = "사용정지"
            //   couponInfo[i].useStat = useStat
            //   couponInfo[i].useStatText = useStatText
            // }
            else if(couponInfo[i].cpUseFlag == "Y" || (couponInfo[i].cpUseDate != undefined))
            {
              useStat = "N"   //사용불가
              useStatText = "사용완료"
              couponInfo[i].useStat = useStat
              couponInfo[i].useStatText = useStatText
            }
            else
            {
              if(this.getDateFormat(couponInfo[i].cpExpDate).replace(/-/g, "") < this.today.replace(/-/g, ""))
              {
                useStat = "N"   //사용불가
                useStatText = "기한만료"

                couponInfo[i].useStat = useStat
                couponInfo[i].useStatText = useStatText
              }
              else if(this.getDateFormat(couponInfo[i].cpExpDate).replace(/-/g, "") >= this.today.replace(/-/g, ""))
              {
                useStat = "Y"   //사용가능
                useStatText = "미사용"

                couponInfo[i].useStat = useStat
                couponInfo[i].useStatText = useStatText
              }
            }
          }

          // 멥버십 전용쿠폰
          else if(couponInfo[i].memCpFlag == "Y") 
          {
            if(couponInfo[i].cpType === "A") 
            {
              if(couponInfo[i].cpValidFlag == "N")
              {
                useStat = "N"   //사용불가
                useStatText = "사용정지"
                couponInfo[i].useStat = useStat
                couponInfo[i].useStatText = useStatText
              }
              else if(couponInfo[i].cpUseFlag == "Y" || (couponInfo[i].cpUseDate != undefined))
              {
                useStat = "N"   //사용불가
                useStatText = "사용완료"
                couponInfo[i].useStat = useStat
                couponInfo[i].useStatText = useStatText
              }
              else
              {
                if(this.getDateFormat(couponInfo[i].memCpExDate).replace(/-/g, "") < this.todayTime.replace(/-/g, ""))
                {
                  useStat = "N"   //사용불가
                  useStatText = "기한만료"

                  couponInfo[i].useStat = useStat
                  couponInfo[i].useStatText = useStatText
                }
                else if(this.getDateFormat(couponInfo[i].memCpStDate).replace(/-/g, "") <= this.todayTime.replace(/-/g, "") && this.getDateFormat(couponInfo[i].memCpExDate).replace(/-/g, "") >= this.todayTime.replace(/-/g, ""))
                {
                  useStat = "Y"   //사용가능
                  useStatText = "미사용"

                  couponInfo[i].useStat = useStat
                  couponInfo[i].useStatText = useStatText
                }
                else //if(this.getDateFormat(couponInfo[i].memCpExDate_sub).replace(/-/g, "") >= this.todayTime.replace(/-/g, ""))
                {
                  useStat = ""   //아직 사용불가(Not Yet)
                  useStatText = "사용기간전"

                  couponInfo[i].useStat = useStat
                  couponInfo[i].useStatText = useStatText
                }                
              }
            }
            else if(couponInfo[i].cpType === "B") 
            {
              if(couponInfo[i].validFlag == "N")
              {
                useStat = "N"   //사용불가
                useStatText = "사용정지"
                couponInfo[i].useStat = useStat
                couponInfo[i].useStatText = useStatText
              }
              else if(couponInfo[i].cpUseFlag == "Y" || (couponInfo[i].cpUseDate != undefined))
              {
                useStat = "N"   //사용불가
                useStatText = "사용완료"
                couponInfo[i].useStat = useStat
                couponInfo[i].useStatText = useStatText
              }
              else
              {
                if(this.getDateFormat(couponInfo[i].cpExpDate).replace(/-/g, "") < this.todayTime.replace(/-/g, ""))
                {
                  useStat = "N"   //사용불가
                  useStatText = "기한만료"

                  couponInfo[i].useStat = useStat
                  couponInfo[i].useStatText = useStatText
                }
                else if(this.getDateFormat(couponInfo[i].cpExpDate).replace(/-/g, "") >= this.todayTime.replace(/-/g, ""))
                {
                  useStat = "Y"   //사용가능
                  useStatText = "미사용"

                  couponInfo[i].useStat = useStat
                  couponInfo[i].useStatText = useStatText
                }
              }
            }
          }
        }
      }
      this.couponInfo = couponInfo;
      // console.log("this.couponInfo>>>>>", this.couponInfo)
      // //초기값은 유효쿠폰만
      // this.userCoupon_info = this.couponInfo.filter(e => {
      //   return e.useStat == "Y"
      // })
    },


    //about UserInfo
    async getUserInfo() 
    {
      let userInfo = await this.$api("/api/checkMemEmail", {param: [this.user.email]});
      if(userInfo.length > 0) 
      {
        this.userInfo = userInfo[0];
      }
      // console.log("userInfo:::", this.userInfo)

      this.getCountCustomerAsk(this.userInfo.uEmail)    //1:1카운트
      this.getCountInquiry(this.userInfo.uEmail)        //상품문의카운트
      this.getCountQuotation(this.userInfo.uEmail)      //상품문의카운트
      //포인트관련(미확정이 있으면 제거가 먼저)
      this.rmStandbyPoint();
      // this.getUserCouponInfo()                          //소유쿠폰정보취득

      //뉴멤버십 유무
      if(userInfo[0].newMem == "Y")
      {
        let userMemInfo = await this.$api("/api/checkMembershipInfo_new", {param: [this.user.email]});

        //멤버십 정보존재
        if(userMemInfo.length > 0)
        {
          this.userMemInfo = userMemInfo[0]

          let alimCall_tmp = ""
          if(this.userInfo.alimCallC != undefined &&this.userInfo.alimCallC.charAt(0) === '+')
          {
            alimCall_tmp = this.userInfo.alimCallC.replace("+82 ", "0")
            this.k_tel = alimCall_tmp.replace(/-/g,"");
          }
          else 
          {
            this.k_tel = this.userInfo.alimCallC.replace(/-/g,"");
          }

          this.k_name = this.userInfo.uNickName
          //console.log("k_name:",this.k_name, "k_tel:",this.k_tel, "userMemInfo:", this.userMemInfo)


          // // 멤버십 전용쿠폰 발행체크
          // let getMemCpList = await this.$api("/api/memberCouponList", {param: [ this.user.email ] })
          // this.myMemCpList = getMemCpList;
          // console.log("myMemCpList:::::::", this.myMemCpList)

          // // 1. 조회일이 사용가능기간인 월할인쿠폰 발행체크
          // let cp_A = this.myMemCpList.filter(e => {
          //   return (e.memCpType === "A" && (this.todayTime >= moment(e.memCpStDate_sub).format('YYYY-MM-DD HH:mm:ss') && this.todayTime <= moment(e.memCpExDate_sub).format('YYYY-MM-DD HH:mm:ss')))
          // })
          // // console.log("cp_A:::::::", cp_A)

          // // 1-1. 미발행
          // if(cp_A.length < 1)
          // {
          //   this.$swal.fire("", "月할인 쿠폰이 검색되지 않습니다<br>죄송합니다만, 고객센터(1660-4602)로 문의해주세요.","warning")
          //   return false
          // }
          // // 2. 신규상품 할인쿠폰 발행체크
          // let cp_B = this.myMemCpList.filter(e => {
          //   return (e.memCpType === "B" && (this.todayTime >= moment(e.memCpStDate).format('YYYY-MM-DD HH:mm:ss') && this.todayTime <= moment(e.memCpExDate).format('YYYY-MM-DD HH:mm:ss')))
          // })
          // console.log("cp_B:::::::", cp_B)

          // // 2-1. 미발행
          // if(cp_B.length < 1) 
          // {
          //   this.$swal.fire("", "신상품 할인쿠폰이 검색되지 않습니다<br>죄송합니다만, 고객센터(1660-4602)로 문의해주세요.","warning")
          //   return false
          // }
        }
      }
      
      await this.checkIssuedCoupon(this.userInfo.newMem, this.k_tel, this.user.email)   //멤버십 가입여부에 따라 쿠폰체크 범위분기처리
    },

    async deletePhoto(){
      //삭제할 파일명
      let param = this.userInfo.photo
      let flag = "myPage"
      let response = await this.$api("/api/deletePhoto", {param: param, flag})    //call back-end

      if(response != undefined)
      {
        let memberPhotoUpdate = await this.$api("/api/memberPhotoUpdate", {param: [
          '', this.user.email
        ]});


        if(memberPhotoUpdate.affectedRows >= 0)
        {
          this.$swal.fire("","사진이 삭제되었습니다", "info")
          location.reload(true)
        }
        else
        {
          this.$swal.fire("","삭제를 다시 진행해 주세요", "warning")
          return false;
        }
      }
    },

    changePhoto(){
      //숨겨진 이벤트를 호출
      this.$refs.fileInput.click();
    },
    async handleFileChange(){
      //let file = document.getElementById('fileInput').files[0];
      let file = this.$refs.fileInput.files[0];
      if(file)
      {
        let fileSizeInKB = file.size/1024

        if(fileSizeInKB > 1000)
        {
          this.$swal.fire("","이미지의 사이즈는 1mb를 초과할 수 없습니다.","warning")
          return false;
        }
        else
        {
          //아이디를 파일명으로 저장처리
          //let memId = this.user.email
          //let fileType = file.name.split(".").pop().toLowerCase()

          //backend의 multer이용
          const formData = new FormData()
          //let newFileName = imgName

          formData.append('image', file)
          formData.append('memberid', this.user.email)

          let config = {
            headers: {
              'memid': this.user.email
            }
          }
          //console.log("config:", config)

          //let response = await this.$api("http://localhost:5000/uploads/memberPhoto/", formData, config)
          let response = await this.$api("https://ntabi.co.kr/uploads/memberPhoto/", formData, config)

          if(response != undefined)
          {
            let memberPhotoUpdate = await this.$api("/api/memberPhotoUpdate", {param: [
              response.imageName, this.user.email
            ]});

            if(memberPhotoUpdate.affectedRows >= 0)
            {
              this.$swal.fire("","사진이 등록되었습니다", "info")
              location.reload(true)
            }
            else
            {
              this.$swal.fire("","사진을 재등록해주세요.", "warning")
              return false;
            }
          }
        }
      }
    },

    goToMyPageInfoChange(){
      this.$router.push({path: '/myPageInfoChange'});
    },

    joinToMembership(param){
      if(param == undefined)
      {
        this.$swal.fire("","멤버십 가입을 위한 정보가 부정확합니다. 다시 로그인해주세요.","question")
        return false;
      }
      else
      {
        this.$router.push({path: '/MyPageInfoChange_joinM'});
      }
    },    


    //사용대기 포인트가 있으면 삭제 후, 포인트 재계산
    async rmStandbyPoint()
    {
      //console.log("rmStandbyPoint")
      let waitingPoint = await this.$api("/api/userStandbyPoint", {param: [this.user.email]})
      {
        if(waitingPoint.length > 0)
        {
          let rmPoint = await this.$api("/api/rmPoint", {param: [this.user.email, 'S']});
          //삭제성공
          if(rmPoint.affectedRows < 0 || rmPoint.affectedRows == undefined )
          {
            this.$swal.fire("","죄송합니다. 포인트 조회에 문제가 발생했습니다.","warning")
            return false
          }
          // else
          // {
          //   this.getUserPoint();
          //   this.getAvailPoint();
          // }
        }
        this.getUserPoint();
        this.getAvailPoint();
      }
      //console.log("rmPoint:",rmPoint);
    },
    async getUserPoint(con) 
    {
      if (con === "all" || con === "" || con === undefined) 
      {
        con = "%"; 
      }
      let resUserPoint = await this.$api("/api/getUserPoint", {param: [this.user.email, con]});
      if(resUserPoint.length > 0) 
      {
        this.resUserPoint = resUserPoint;
      }
      //console.log("resUserPoint:",this.resUserPoint);
    },

    //공통함수사용(commonFunctions.js)
    async getAvailPoint() 
    {
      this.availPoint = await getAvailPoint(this.$api, this.user.email)
    },

    //About NBUS
    async getReqProcLevel() 
    {
      let rProc = await this.$api("/api/reqProcLevel", {});
      if(rProc.length > 0) 
      {
        this.rProc = rProc
      }
      //console.log("rProc:",this.rProc);
    },

    async getRequestConsultList_nbus(f)
    {
      //console.log("dFlag:",this.dFlag)
      this.dFlag_nbus = (f==="past") ? 'past' : ''

      let reqListNbus = await this.$api("/api/nbusInqList_nbus", {param:[this.user.email]});
      //console.log("reqListNbus:",reqListNbus)

      if(f == "past")
      {
        this.reqListAll_nbus = reqListNbus.filter(e => {
          return this.getDateFormat(e.rentStartDate) < this.today
        });
      }
      else
      {
        this.reqListAll_nbus = reqListNbus.filter(e => {
          return this.getDateFormat(e.rentStartDate) >= this.today
        });
      }

      //console.log("reqListAll_nbus:", this.reqListAll_nbus)

      let i = 0
      while(i < this.reqListAll_nbus.length)
      {
        let accPayStatus = ""
        if(this.reqListAll_nbus[i].inqStatus === "WP")
        {
          let virAccInfo = await this.$api("/api/res_virAccPayInfo", {param: [this.reqListAll_nbus[i].inqCode]});
          //console.log("virAccInfo:", virAccInfo)
          if(virAccInfo.length > 0)
          {
            if((virAccInfo[0].payStyle === "fu" && virAccInfo[0].payFlag1 === "Y") || (virAccInfo[0].payStyle === "p2" && virAccInfo[0].payFlag2 === "Y"))
            {
              accPayStatus = "결제완료(담당자 확인 중)" 
            }
            else if((virAccInfo[0].payStyle === "p1" && virAccInfo[0].payFlag1 === "Y") || (virAccInfo[0].payStyle === "p2" && virAccInfo[0].payFlag2 === "N"))
            {
              accPayStatus = "잔액입금대기" 
            }
            else
            {
              accPayStatus = "입금대기"
            }
            //this.reqListAll[i].accPayStatus.push(accPayStatus)
            this.reqListAll_nbus[i].accPayStatus = accPayStatus
          }
        }

        else if (this.reqListAll_nbus[i].inqStatus === "PY") {
          if (this.reqListAll_nbus[i].payFlag === "fu" || this.reqListAll_nbus[i].payFlag === "p2" || this.reqListAll_nbus[i].payFlag == null) {
            this.reqListAll_nbus[i].payStyle = "f";
          } else if (this.reqListAll_nbus[i].payFlag === "p1") {
            this.reqListAll_nbus[i].payStyle = "p";
          }
        }
        i++
      }
    },

    //about Reservation
    async getRequestConsultList(f)
    {
      //console.log("dFlag:",this.dFlag)
      this.dFlag = (f==="past") ? 'past' : ''

      let reqListRes = await this.$api("/api/getMyResList_new", {param:[this.user.email]});
      let reqListEvt = await this.$api("/api/getMyEvtList", {param:[this.user.email]});
      let reqList = reqListRes.concat(reqListEvt);
      //console.log("reqListRes:",reqListRes)

      if(f == "past")
      {
        this.reqListAll = reqList.filter(e => {
          return this.getDateFormat(e.closeDate) < this.today
        });
      }
      else
      {
        this.reqListAll = reqList.filter(e => {
          return this.getDateFormat(e.closeDate) >= this.today
        });
      }

      // console.log("reqListAll:", this.reqListAll)

      let i = 0
      while(i < this.reqListAll.length)
      {
        let accPayStatus = ""
        if(this.reqListAll[i].reqStatus === "WP")             //가상계좌 + 입금대기
        {
          let virAccInfo = await this.$api("/api/res_virAccPayInfo", {param: [this.reqListAll[i].resCode]});
          //console.log("virAccInfo:", virAccInfo)
          if(virAccInfo.length > 0)
          {
            if((virAccInfo[0].payStyle === "fu" && virAccInfo[0].payFlag1 === "Y") || (virAccInfo[0].payStyle === "p2" && virAccInfo[0].payFlag2 === "Y"))
            {
              accPayStatus = "결제완료(담당자 확인 중)" 
            }
            else if((virAccInfo[0].payStyle === "p1" && virAccInfo[0].payFlag1 === "Y") || (virAccInfo[0].payStyle === "p2" && virAccInfo[0].payFlag2 === "N"))
            {
              accPayStatus = "잔액입금대기" 
            }
            else
            {
              accPayStatus = "입금대기"
            }
            //this.reqListAll[i].accPayStatus.push(accPayStatus)
            this.reqListAll[i].accPayStatus = accPayStatus
          }
        }

        else if (this.reqListAll[i].reqStatus === "PY" || this.reqListAll[i].reqStatus === "CO") 
        {
          if (this.reqListAll[i].payFlag === "fu" || this.reqListAll[i].payFlag === "p2" || this.reqListAll[i].payFlag == null) 
          {
            this.reqListAll[i].payStyle = "f";
          } 
          else if (this.reqListAll[i].payFlag === "p1") 
          {
            this.reqListAll[i].payStyle = "p";
          }
        }
        i++
      }
    },

    //선택옵션획득
    async getSelOptions(resCode) {
      let selOptions = []
      let useFlag = "Y"
      let tot_selOptPrice = 0

      selOptions = await this.$api("/api/getSelOptions", {param: [resCode, useFlag]});

      if(selOptions.length > 0)
      {
        //this.selOptions = selOptions
        
        selOptions.forEach(so => {
          tot_selOptPrice += (so.prcOpt * so.qtyOpt)})
      }
      else
      {
        tot_selOptPrice = 0
      }
      //console.log("tot_selOptPrice:", tot_selOptPrice)
      return tot_selOptPrice
    },

    //선택추가상품획득
    async getSelAddProductions(resCode) {
      let selAddPdt = []
      let useFlag = "Y"
      let tot_selAddPdtPrice = 0
      selAddPdt = await this.$api("/api/getSelAddProductions", {param: [resCode, useFlag]});

      if(selAddPdt.length > 0)
      {
        //this.selAddPdt = selAddPdt
        selAddPdt.forEach(sa => {
          tot_selAddPdtPrice += (sa.addPdtPrice * sa.qty_addPdt)
        });
      }
      else
      {
        tot_selAddPdtPrice = 0
      }
      //console.log("tot_selAddPdtPrice:", tot_selAddPdtPrice)
      return tot_selAddPdtPrice
    },

    goToReqReserveDetail(path, seqReq, pCode, ntCode1) {
      if(path === "N")
      {
        this.$router.push({path: '/reserveInfoDetail_client', query: {seqReq: seqReq, cCode: 'N'}})
      }
      else
      {
        if(seqReq.substr(0,2) === "RQ")
        {
          this.$router.push({path: '/reserveInfoDetail_client', query: {seqReq: seqReq, pCode: pCode, cCode: 'Y'}});
        }
        else
        {
          this.$router.push({path: '/eventInfo_client', query: {eCode: seqReq, ntCd: ntCode1}});
        }
      }
    },

    goToProductDetail(pCode) {
      let sRoute = ""
      sRoute = pCode.charAt(0)

      this.$router.push({path: '/detail', query: {productId: pCode, salesRoute: sRoute}});
    },

    //1:1문의 건수
    async getCountCustomerAsk(uId){
      let countCustomerAsk = await this.$api("/api/countCustomerAsk", {param: [uId]})
      
      if(countCustomerAsk.length > 0)
      {
        this.countCustomerAsk = countCustomerAsk[0]
        this.countCustomerAsk.totNoAns = this.countCustomerAsk.totAsk*1 - this.countCustomerAsk.totAns*1
      }
      //console.log("countCustomerAsk:", this.countCustomerAsk)
    },

    //상품문의 건수
    async getCountInquiry(userId){
      let countInquiry = await this.$api("/api/countInquiry", {param: [userId]})
      
      if(countInquiry.length > 0)
      {
        this.countInquiry = countInquiry[0]
        this.countInquiry.totNoAns = this.countInquiry.totAsk*1 - this.countInquiry.totAns*1
      }
      //console.log("countInquiry:", this.countInquiry)
    },

    //견적문의 건수
    async getCountQuotation(mId){
      let countQuotation = await this.$api("/api/countQuotation", {param: [mId]})
      
      if(countQuotation.length > 0)
      {
        this.countQuotation = countQuotation[0]
        this.countQuotation.totNoAns = this.countQuotation.totAsk*1 - this.countQuotation.totAns*1
      }
      //console.log("countQuotation:", this.countQuotation)
    },    


    //1:1문의 바로가기
    goToCustomerAskDetail(askCode) {  //askCode: 질문번호
      this.$router.push({path: '/customerAsk', query: {askCode: askCode}});
      //console.log("oId:", orderId);
    },
    //견적문의 바로가기
    goToRequestQuoDetail() {
      this.$router.push({path: '/requestQuotation', query: {}});
      //console.log("oId:", orderId);
    },

    goToMyPageRequestList(tab) {  //askCode: 질문번호
      this.$router.push({path: '/myPageRequestList', query: {askCode: tab}});
    },




    // //about 1on1 inquiry
    // async getCustomerAskList() {
    //   this.reqFlag = 'C';
    //   let reqList = await this.$api("/api/customerAskList_myPage", {param: [this.user.email]});
    //   if(reqList.length > 0) {
    //     this.reqList = reqList;
    //   }
    //   console.log("reqList:",this.reqList);
    // },

    // //about Quotation
    // async getRequestQuotationList() 
    // {
    //   let reqList_quo = await this.$api("/api/reqQuotationList1", {param: [this.user.email]});
    //   if(reqList_quo.length > 0) {
    //     this.reqList_quo = reqList_quo;
    //   }
    //   console.log("reqList_quo:",this.reqList_quo);
    // },


    // //about Inquiry
    // async getRequestList() {
    //   this.reqFlag = 'R';
    //   let reqList_inq = await this.$api("/api/requestList_myPage", {param: [this.user.email]});
    //   if(reqList_inq.length > 0) {
    //     this.reqList_inq = reqList_inq;
    //   }
    //   console.log("reqList_inq:",this.reqList_inq);
    // },
    


    goToHome() {
      this.$router.push({path: '/'});
    },
    async changeAlimCall()
    {
      const { value: alim } = await this.$swal.fire({
          html: '알림을 받을 연락처를 변경합니다',
          input: 'text',
          //inputLabel: '뱃지표시',
          inputPlaceholder: '(예시: 000-1111-2222)'
        })

        //console.log("alim:",alim)
      let result = this.validatePhoneNumber(alim)
      if(!result)
      {
        this.$swal.fire('', '유효하지 않은 연락처 번호입니다.', 'warning')
        return false;
      }
      else
      {
        if (alim) 
        {
          this.$swal.fire('',`변경된 연락처: ${alim}`)
          let changeAlimNo = await this.$api("/api/changeAlimNo", {param: [alim, this.user.email]});
          if(changeAlimNo.affectedRows < 0 || changeAlimNo.affectedRows === undefined)
          {
            this.$swal.fire('', '변경 중 오류가 발생했습니다(코드:changeAlimNo)', 'alert')
          }
          else
          {
            this.$swal.fire('', '변경되었습니다. 감사합니다.', 'success')
            location.reload(true)
          }
        }
      }
    },
    //입력된 연락처 검증
    validatePhoneNumber(no) 
    {
      const regex = /^\d{3}-\d{3,4}-\d{4}$/;
      return regex.test(no);
    },

    //About point
    async changeCondition(con) {
      //alert("con:"+con)
      this.getUserPoint(con);
    },

    //취소요청처리
    async reqCxl(rCode, flag, seq, pCode)
    {
      //상품별 취소안내사항
      let res_supCxl = await this.$api("/api/supCxl", {param: pCode})

      let supCxl = ""
      if(res_supCxl.length > 0)
      {
        supCxl = res_supCxl[0]
      }
      this.$swal.fire({
        html: "예약취소를 요청하시겠습니까?<br><br><p class='text-start swal-popup'>"+ supCxl.supCancellation.split('\n').join('<br>') +"</p>",
        showCancelButton: true,
        confirmButtonText: '동의하고 요청합니다',
        cancelButtonText: '요청하지 않습니다',
        width: 1000,
      }).then(async (result) => {
        if(result.isConfirmed) {
          let conFlag = "Y"   //취소약관동의
          let insReqCxlReserve = await this.$api("/api/insReqCxlReserve", {param: [
            rCode, this.user.email,conFlag
          ]});
          if(Object.keys(insReqCxlReserve)[0] === 'error') 
          {
            this.$swal.fire('','요청처리 중 오류가 발생했습니다.<br>온라인 문의 또는 연락(1660-4602)을 주시면 신속하게 처리해드리겠습니다.', 'warning')
            return false;
          }
          else
          {
            this.sendKakao("RCX", flag, seq, rCode)
          }
        }
      })
    },

    //엔버스취소요청처리
    async reqCxl_nbus(nCode, flag, seq)     //nbus 'n' i 
    {
      //상품별 취소안내사항
      let res_supCxl = await this.$api("/api/supCxl_nbus", {param: nCode})

      let supCxl = ""
      if(res_supCxl.length > 0)
      {
        supCxl = res_supCxl[0]
      }
      this.$swal.fire({
        html: "예약취소를 요청하시겠습니까?<br><br><p class='text-start swal-popup'>"+ supCxl.supCancellation.split('\n').join('<br>') +"</p>",
        showCancelButton: true,
        confirmButtonText: '동의하고 요청합니다',
        cancelButtonText: '요청하지 않습니다',
        width: 1000,
      }).then(async (result) => {
        if(result.isConfirmed) {
          let conFlag = "Y"   //취소약관동의
          let insReqCxlReserve = await this.$api("/api/insReqCxlReserve", {param: [
            nCode, this.user.email,conFlag
          ]});
          if(Object.keys(insReqCxlReserve)[0] === 'error') 
          {
            this.$swal.fire('','요청처리 중 오류가 발생했습니다.<br>온라인 문의 또는 연락(1660-4602)을 주시면 신속하게 처리해드리겠습니다.', 'warning')
            return false;
          }
          else
          {
            this.sendKakao("RCX", flag, seq, nCode)           // "n" i NB-XXXXX
          }
        }
      })
    },

    async getHandlerInfo()
    {
      let handTel = await handlerInfo(this.$api);
      if(handTel.length > 0)
      {
        this.handTel = handTel
      }
      //console.log("handTel: ", this.handTel)
    },

    /** 카카오알림 발송 */
    async sendKakao(param, flag, seq, code)
    {
      let insKSendHistory = await this.$api("/api/insKSendHistory", {param: [
        code, param, this.k_tel
      ]});

      //알림톡 발송대상 확정
      this.handTel.push({aimCall: this.k_tel})
      this.handTelCnt = this.handTel.length
      // console.log("handTel:", this.handTel, "handTelCnt:", this.handTelCnt)
      // let reqCxlDate = ""           //취소요청일자
      // if(param === "RCX")
      // {
      //   let reqCxlInfo = this.$api("/api/checkReqCxl", {param: [ code ]})

      //   if(reqCxlInfo.length > 0)
      //   {
      //     reqCxlDate = this.getDateFormat(reqCxlInfo[0].insDate)
      //   }
      //   else
      //   {
      //     reqCxlDate = this.today
      //   }
      // }
      let kakaoAlimData = {}

      if(insKSendHistory.affectedRows > 0)
      {
        let promises = []

        if(flag ==='j')
        {
          for(let j=0; j<this.handTelCnt; j++)
          {
            kakaoAlimData = 
            {
              clientName: this.k_name,
              resName: this.reqListReqRes[seq].resName,
              resPaxName: this.reqListReqRes[seq].myName,
              resPaxCnt: this.reqListReqRes[seq].reqTotCnt,
              dptDate: this.getDateFormat(this.reqListReqRes[seq].startDate),
              resPhone: this.reqListReqRes[seq].myTel,
              resCode: this.reqListReqRes[seq].resCode,
              resManager: this.reqListReqRes[seq].managerName,
              alimFlag: param,                                             //알림유형(RCX:취소요청)
              clientCall: this.handTel[j].aimCall,                           //알림톡발송대상
            };

            let promise_j = this.$api("api/kakaoAlimSend2", {
              param: [ { kakaoAlimData: kakaoAlimData} ]
            })

            promises.push(promise_j)
          }

        }
        else if(flag === 'i')
        {
          for(let i=0; i<this.handTelCnt; i++)
          {
            kakaoAlimData = 
            {
              clientName: this.k_name,
              resName: this.reqListAll[seq].resName,
              resPaxName: this.reqListAll[seq].myName,
              resPaxCnt: this.reqListAll[seq].reqTotCnt,
              dptDate: this.getDateFormat(this.reqListAll[seq].startDate),
              resPhone: this.reqListAll[seq].myTel,
              resCode: this.reqListAll[seq].resCode,
              resManager: this.reqListAll[seq].managerName,
              alimFlag: param,                                             //알림유형(RCX:취소요청)
              clientCall: this.handTel[i].aimCall,                           //알림톡발송대상
            };

            let promise_i = this.$api("api/kakaoAlimSend2", {
              param: [ { kakaoAlimData: kakaoAlimData} ]
            })

            promises.push(promise_i)
          }
        }
        //엔버스 취소요청
        else if(flag === 'n')
        {
          for(let n=0; n<this.handTelCnt; n++)
          {
            kakaoAlimData = 
            {
              inqName: this.k_name,
              inqCode: this.reqListAll_nbus[seq].inqCode,
              rentStartDate: this.getDateFormat(this.reqListAll_nbus[seq].rentStartDate),
              inqTel: this.reqListAll_nbus[seq].inqTel,
              alimFlag: param,                                             //알림유형(RCX:취소요청)
              clientCall: this.handTel[n].aimCall,                           //알림톡발송대상
              memFlag: "Y",
            };
            // console.log("kakaoAlimData:>>>>>>>", kakaoAlimData)

            let promise_n = this.$api("api/kakaoAlimSend7", {
              param: [ { kakaoAlimData: kakaoAlimData} ]
            })

            promises.push(promise_n)
          }
        }
        //반복문 이후 처리
        Promise.all(promises).then((results) => {
          console.log(results)
          this.$swal.fire('', '취소요청 알림톡이 발송되었습니다', 'success').then(() => {
            //location.reload(true)
          })
        }).catch((error) => {
          console.log("Error calling api: ", error)
        })
      }

      // let insKSendHistory = await this.$api("/api/insKSendHistory", {param: [
      //   kakaoAlimData.resCode, param, this.user.email
      // ]});

      // //알림톡 발송대상 확정
      // this.handTel.push({aimCall: this.userInfo.alimCallC})
      // this.handTelCnt = this.handTel.length

      // #{clientName}님, 요청하신 예약의 취소가 접수되었습니다.
      // 즉시 취소가 불가능한 경우 담당자가 상담연락을
      // 드릴 예정입니다.

      // - 예약상품: #{resName}
      // - 예약자명: #{resPaxName}
      // - 여행인원: #{resPaxCnt}
      // - 여행일자: #{dptDate}
      // - 고객연락처: #{resPhone}
      // - 예약번호: #{resCode}
      // - 담당자: #{resManager} 매니저
      // - 예약확인: #{resCheck}
      // if(insKSendHistory.affectedRows > 0) {
      //   if(param == "RCX") 
      //   {
      //     //kakaoAlimData
      //     this.$api("api/kakaoAlimSend2", {
      //       param: [
      //         { kakaoAlimData: kakaoAlimData},
      //       ]
      //     }).then((res) => {console.log(res)});
      //     this.$swal.fire('', '취소요청 알림톡이 발송되었습니다', 'success');
      //     location.reload(true)
      //   }
      // }
    },
  }
}
</script>




<style scoped>
/* ============================================================
   CSS 변수 / 기본설정
============================================================ */
#mypage {
  --green: #86cd53;
  --green-dark: #5fa033;
  --green-light: #d4f0b8;
  --green-xlight: #f0fbe7;
  --charcoal: #2b3a2b;
  --charcoal-light: #3d5c3d;
  --gold: #c8952a;
  --gold-light: #e9c46a;
  --teal: #3aab6f;
  --bg: #f5faf2;
  --card-bg: #ffffff;
  --border: #ddefd4;
  --text-main: #1e2e1e;
  --text-sub: #6b7c6b;
  --radius: 14px;
  --shadow: 0 2px 16px rgba(90,160,51,0.10);
  
  background: var(--bg);
  font-family: 'Noto Sans KR', 'Apple SD Gothic Neo', sans-serif;
  padding-bottom: 5rem;
}

/* ============================================================
   페이지 헤더
============================================================ */
.page-header {
  position: relative;
  background: linear-gradient(135deg, var(--charcoal) 0%, var(--charcoal-light) 50%, #4e7a3a 100%);
  padding: 3rem 0 2.5rem;
  margin-bottom: 2rem;
  overflow: hidden;
}
.page-header::before {
  content: '';
  position: absolute;
  top: -40px; right: -40px;
  width: 220px; height: 220px;
  border-radius: 50%;
  background: rgba(134,205,83,0.15);
}
.page-header::after {
  content: '';
  position: absolute;
  bottom: -1px;
  left: 0; right: 0;
  height: 28px;
  background: var(--bg);
  border-radius: 28px 28px 0 0;
}
.header-bg {
  position: absolute;
  inset: 0;
  background: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%2386cd53' fill-opacity='0.05'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E") repeat;
}
.page-title {
  position: relative;
  color: #fff;
  font-size: 1.6rem;
  font-weight: 700;
  letter-spacing: 0.15em;
  margin: 0;
  text-align: center;
}
.page-title::after {
  content: '';
  display: block;
  width: 40px;
  height: 3px;
  background: var(--green);
  border-radius: 2px;
  margin: 0.5rem auto 0;
}

/* ============================================================
   사이드바
============================================================ */
.sidebar {
  position: sticky;
  top: 1rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

/* 프로필 카드 */
.profile-card {
  background: var(--card-bg);
  border-radius: var(--radius);
  box-shadow: var(--shadow);
  overflow: hidden;
}
.profile-photo-wrap {
  position: relative;
  background: linear-gradient(135deg, var(--charcoal), var(--charcoal-light));
  padding: 2rem 0 3rem;
  text-align: center;
}
.photo-circle {
  position: relative;
  display: inline-block;
  cursor: pointer;
  border-radius: 50%;
}
.photo-img {
  width: 90px;
  height: 90px;
  border-radius: 50%;
  object-fit: cover;
  border: 3px solid rgba(255,255,255,0.3);
  display: block;
  transition: opacity 0.2s;
}
.photo-overlay {
  position: absolute;
  inset: 0;
  background: rgba(0,0,0,0.4);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 1.2rem;
  opacity: 0;
  transition: opacity 0.2s;
}
.photo-circle:hover .photo-overlay { opacity: 1; }
.photo-circle:hover .photo-img { opacity: 0.7; }
.photo-del-btn {
  position: absolute;
  bottom: 2.2rem;
  right: calc(50% - 60px);
  width: 26px; height: 26px;
  border-radius: 50%;
  background: #fff;
  border: 1px solid #ddd;
  display: flex; align-items: center; justify-content: center;
  font-size: 0.65rem;
  color: #e74c3c;
  padding: 0;
  transition: background 0.2s;
  cursor: pointer;
}
.photo-del-btn:hover { background: #fee; }

.profile-info {
  padding: 1rem 1.5rem 1.5rem;
  text-align: center;
  margin-top: -1.2rem;
  position: relative;
}
.profile-name {
  font-size: 1.4rem;
  font-weight: 700;
  color: var(--text-main);
  margin-bottom: 0.5rem;
}
.profile-name .nim {
  font-size: 1rem;
  font-weight: 400;
  color: var(--text-sub);
}
.profile-detail {
  font-size: 0.8rem;
  color: var(--text-sub);
  margin-bottom: 0.2rem;
}
.profile-detail i { color: var(--navy); }

.membership-badge {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  background: linear-gradient(135deg, #f0fbe7, #e0f5cc);
  border: 1px solid var(--green);
  border-radius: 10px;
  padding: 0.6rem 1rem;
  margin: 0.8rem 0;
  text-align: left;
}
.trophy-icon { font-size: 1.4rem; color: var(--green-dark); flex-shrink: 0; }
.badge-title { display: block; font-weight: 700; font-size: 0.85rem; color: var(--charcoal); }
.badge-no { display: block; font-size: 0.72rem; color: #999; }
.badge-exp { display: block; font-size: 0.72rem; color: var(--green-dark); }

.membership-join { margin: 0.8rem 0; }
.btn-join {
  width: 100%;
  background: linear-gradient(135deg, var(--green-dark), var(--green));
  color: #fff;
  border-radius: 60px;
  font-size: 0.85rem;
  font-weight: 600;
  padding: 0.5rem 1rem;
  border: none;
  transition: opacity 0.2s;
}
.btn-join:hover { opacity: 0.88; color: #fff; }

.btn-edit-info {
  width: 100%;
  background: var(--green-xlight);
  color: var(--charcoal);
  border: 1px solid var(--border);
  border-radius: 60px;
  font-size: 0.82rem;
  padding: 0.45rem 1rem;
  margin-top: 0.5rem;
  transition: background 0.2s;
}
.btn-edit-info:hover { background: var(--green-light); }

/* 포인트 카드 */
.point-card {
  background: linear-gradient(135deg, var(--green-dark), var(--green));
  border-radius: var(--radius);
  padding: 1.2rem 1.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 4px 16px rgba(134,205,83,0.3);
}
.point-label {
  color: rgba(255,255,255,0.85);
  font-size: 0.82rem;
}
.point-value {
  color: #fff;
  font-size: 1.5rem;
  font-weight: 700;
  text-decoration: none;
  transition: color 0.2s;
}
.point-value:hover { color: #f0fbe7; }
.point-unit { font-size: 0.9rem; margin-left: 2px; }

/* 쿠폰 등록 카드 */
.coupon-reg-card {
  background: var(--card-bg);
  border-radius: var(--radius);
  padding: 1.2rem 1.5rem;
  box-shadow: var(--shadow);
}
.coupon-reg-title {
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--text-main);
  margin-bottom: 0.7rem;
}
.coupon-input {
  width: 100%;
  border: 1px solid var(--border);
  border-radius: 8px;
  padding: 0.45rem 0.75rem;
  font-size: 0.82rem;
  margin-bottom: 0.5rem;
  outline: none;
  transition: border-color 0.2s;
}
.coupon-input:focus { border-color: var(--green); }
.btn-coupon-reg {
  width: 100%;
  background: linear-gradient(135deg, var(--charcoal), var(--charcoal-light));
  color: #fff;
  border-radius: 60px;
  font-size: 0.82rem;
  font-weight: 600;
  padding: 0.45rem;
  border: none;
  transition: opacity 0.2s;
}
.btn-coupon-reg:hover { opacity: 0.88; color: #fff; }

/* ============================================================
   콘텐츠 카드 공통
============================================================ */
.content-card {
  background: var(--card-bg);
  border-radius: var(--radius);
  padding: 1.5rem;
  box-shadow: var(--shadow);
}
.card-header-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-bottom: 1rem;
}
.section-title {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 1.05rem;
  font-weight: 700;
  color: var(--text-main);
  margin: 0;
}
.title-bar {
  display: inline-block;
  width: 4px;
  height: 18px;
  background: var(--green);
  border-radius: 4px;
  flex-shrink: 0;
}
.header-right {
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
}
.pay-legend { font-size: 0.75rem; color: var(--text-sub); }
.toggle-link {
  font-size: 0.78rem;
  color: var(--text-sub);
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: 2px;
  transition: color 0.2s;
}
.toggle-link:hover, .toggle-link.active { color: var(--green-dark); font-weight: 600; }

/* ============================================================
   테이블 (PC)
============================================================ */
.table-wrap { overflow-x: auto; }
.res-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.8rem;
}
.res-table thead tr {
  background: var(--green-xlight);
}
.res-table th {
  padding: 0.7rem 0.6rem;
  text-align: center;
  font-weight: 600;
  color: var(--charcoal);
  font-size: 0.78rem;
  white-space: nowrap;
  border-bottom: 2px solid var(--border);
}
.res-table td {
  padding: 0.85rem 0.6rem;
  text-align: center;
  vertical-align: middle;
  border-bottom: 1px solid var(--border);
  color: var(--text-main);
}
.res-table tbody tr:hover { background: var(--green-xlight); }
.res-table tbody tr:last-child td { border-bottom: none; }

.date-text { font-size: 0.75rem; color: var(--text-sub); }
.days-badge { font-size: 0.7rem; background: #e8f4f8; color: var(--teal); padding: 1px 5px; border-radius: 4px; margin-left: 4px; }

.res-code-link {
  display: block;
  font-size: 0.72rem;
  color: var(--green-dark);
  font-weight: 600;
  text-decoration: underline;
  cursor: pointer;
  margin-top: 2px;
  transition: color 0.15s;
}
.res-code-link:hover { color: var(--charcoal); }
.nbus-link { color: var(--teal); }
.nbus-link:hover { color: #1d7a6f; }

.product-link {
  color: var(--text-main);
  text-decoration: none;
  font-weight: 500;
  cursor: pointer;
  transition: color 0.15s;
  font-size: 0.8rem;
}
.product-link:hover { color: var(--green-dark); text-decoration: underline; }

.price-main { font-size: 0.85rem; font-weight: 700; color: var(--text-main); }
.price-detail { font-size: 0.68rem; color: var(--text-sub); margin-top: 3px; display: flex; flex-direction: column; gap: 1px; align-items: center; }

/* 상태 배지 */
.status-badge {
  display: inline-block;
  font-size: 0.7rem;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 20px;
}
.status-danger  { background: #fff0f0; color: #e63946; }
.status-wait    { background: #fffbe6; color: #b07d00; }
.status-partial { background: #fff3e0; color: #e07b00; }
.status-cancel  { background: #f4f4f4; color: #aaa; }
.status-done    { background: #e6f4ea; color: #2d6a4f; }
.status-default { background: var(--green-xlight); color: var(--green-dark); }

/* 취소 버튼 */
.btn-cxl-outline {
  font-size: 0.72rem;
  padding: 3px 10px;
  border-radius: 6px;
  border: 1px solid #e74c3c;
  color: #e74c3c;
  background: #fff;
  transition: all 0.15s;
  white-space: nowrap;
}
.btn-cxl-outline:hover { background: #e74c3c; color: #fff; }
.btn-cxl-ing {
  font-size: 0.72rem;
  padding: 3px 10px;
  border-radius: 6px;
  border: none;
  background: #e74c3c;
  color: #fff;
  opacity: 0.6;
  white-space: nowrap;
}

/* ============================================================
   모바일 카드
============================================================ */
.pc-table { display: block; }
.mobile-cards { display: none; }

@media (max-width: 767px) {
  .pc-table { display: none; }
  .mobile-cards { display: block; }
}

.mobile-res-card {
  border-radius: 10px;
  overflow: hidden;
  margin-bottom: 0.75rem;
  border: 1px solid var(--border);
}
.mobile-card-header {
  background: linear-gradient(135deg, var(--charcoal), var(--charcoal-light));
  color: #fff;
  padding: 0.7rem 1rem;
  font-weight: 600;
  font-size: 0.88rem;
}
.mobile-card-body { padding: 0.2rem 0; }
.mobile-row {
  display: flex;
  align-items: flex-start;
  padding: 0.5rem 1rem;
  border-bottom: 1px solid #f0f0f0;
  font-size: 0.78rem;
  gap: 0.5rem;
}
.mobile-row:last-child { border-bottom: none; }
.mobile-label {
  flex-shrink: 0;
  width: 70px;
  font-weight: 600;
  color: var(--text-sub);
  font-size: 0.72rem;
  padding-top: 1px;
}

/* ============================================================
   문의 카드
============================================================ */
.inquiry-card {
  background: #fff;
  border: 1px solid var(--border);
  border-radius: 12px;
  padding: 1.2rem 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.7rem;
  transition: box-shadow 0.2s;
  height: 100%;
}
.inquiry-card:hover { box-shadow: 0 4px 20px rgba(134,205,83,0.18); }
.inquiry-icon-wrap {
  width: 44px; height: 44px;
  border-radius: 12px;
  display: flex; align-items: center; justify-content: center;
  font-size: 1.3rem;
}
.inquiry-info { flex: 1; }
.inquiry-more {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.5rem;
}
.inquiry-more h5 {
  font-size: 0.92rem;
  font-weight: 700;
  margin: 0;
  color: var(--text-main);
}
.more-link { font-size: 0.72rem; color: var(--text-sub); text-decoration: none; }
.more-link:hover { color: var(--navy); }
.inquiry-counts { display: flex; flex-direction: column; gap: 4px; }
.count-row { display: flex; justify-content: space-between; font-size: 0.78rem; }
.count-label { color: var(--text-sub); }
.count-val { font-weight: 700; color: var(--text-main); }
.count-val.answered { color: var(--teal); }
.count-val em { font-size: 0.7rem; font-weight: 400; color: var(--text-sub); font-style: normal; margin-left: 2px; }
.btn-inquiry {
  width: 100%;
  background: var(--charcoal);
  color: #fff;
  border-radius: 8px;
  font-size: 0.78rem;
  font-weight: 600;
  padding: 0.4rem;
  border: none;
  transition: background 0.2s;
  margin-top: auto;
}
.btn-inquiry:hover { background: var(--green-dark); color: #fff; }

/* ============================================================
   쿠폰 테이블
============================================================ */
.coupon-table-wrap { overflow-x: auto; }
.coupon-tbl {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.75rem;
}
.coupon-tbl thead {
  background: var(--green-xlight);
}
.coupon-tbl th {
  padding: 0.65rem 0.5rem;
  text-align: center;
  font-weight: 600;
  color: var(--charcoal);
  border-bottom: 2px solid var(--border);
  white-space: nowrap;
}
.coupon-tbl td {
  padding: 0.65rem 0.5rem;
  text-align: center;
  border-bottom: 1px solid var(--border);
  vertical-align: middle;
}
.coupon-tbl tbody tr:hover { background: var(--green-xlight); }
.coupon-tbl tbody tr:last-child td { border-bottom: none; }

.cp-code { font-size: 0.68rem; color: var(--text-sub); }
.cp-expiry { color: #e74c3c; font-weight: 500; }
.cp-price { color: #1a7abf; font-weight: 700; }
.cp-remarks { font-size: 0.7rem; text-align: left; display: block; max-width: 160px; }
.cp-remarks pre { font-size: 0.7rem; margin: 0; white-space: pre-wrap; font-family: inherit; }

.use-stat em { font-size: 0.65rem; font-style: normal; color: var(--text-sub); }
.stat-ok { color: var(--green-dark); font-weight: 600; }
.stat-no { color: #e74c3c; font-weight: 600; }

.cp-disabled { color: #bbb; background: #fafafa; }
.cp-disabled .cp-expiry,
.cp-disabled .cp-price { color: #ccc !important; }
.cp-disabled td { pointer-events: none; }

/* 모바일 쿠폰 */
@media (max-width: 767px) {
  .coupon-tbl thead { display: none; }
  .coupon-tbl, .coupon-tbl tbody, .coupon-tbl tr, .coupon-tbl td { display: block; width: 100%; }
  .coupon-tbl tr { margin-bottom: 12px; border: 1px solid var(--border); border-radius: 8px; overflow: hidden; }
  .coupon-tbl td { text-align: right; padding-left: 40%; position: relative; border-bottom: 1px solid #f0f0f0; }
  .coupon-tbl td::before { content: attr(data-label); position: absolute; left: 10px; width: 38%; text-align: left; font-weight: 600; color: var(--text-sub); }
}

/* ============================================================
   반응형
============================================================ */
@media (max-width: 991px) {
  .page-header { padding: 2rem 0 2rem; }
  .page-title { font-size: 1.3rem; }
  .sidebar { position: static; }
  .content-card { padding: 1rem; }
}
@media (max-width: 575px) {
  .profile-name { font-size: 1.2rem; }
  .inquiry-card { flex-direction: row; flex-wrap: wrap; }
  .count-val { font-size: 1rem; }
}
</style>